import { StaticCanvas } from 'fabric';

import { Coords, SpreadGroundImage } from 'editor/src/store/design/types';

import CustomFabricImage from 'editor/src/fabric/CustomFabricImage';
import { captureException } from 'editor/src/logger';
import getSpreadGroundImageScale from 'editor/src/util/getSpreadGroundImageScale';

import loadGroundImage from './loadGroundImage';

const addSpreadImage = async (
  fabricCanvas: StaticCanvas,
  image: SpreadGroundImage | undefined,
  zIndex: number,
  offset: Coords,
  mm2px: (size: number) => number,
  previewWidth: number,
  previewHeight: number,
  useThumbnails: boolean,
  // Load and measure the ground, but keep it off the canvas. The measurement
  // still feeds the preview's zoom/pan, so hiding a ground never moves the
  // artwork within the raster.
  hideGrounds = false,
  allowUniformScale = true,
) => {
  if (!image) {
    return undefined;
  }

  const imageUrl = useThumbnails ? image.thumbnailUrl : image.url;
  const img = await loadGroundImage(imageUrl);
  if (!img) {
    return undefined;
  }

  try {
    const { scaleX: imageScaleX, scaleY: imageScaleY } = getSpreadGroundImageScale(
      image,
      previewWidth,
      previewHeight,
      mm2px,
      allowUniformScale,
    );

    const fabricImg = new CustomFabricImage(img, {
      getCrossOrigin: () => 'anonymous',
      objectCaching: false,
      angle: 0,
      scaleX: imageScaleX * (image.imgWidth / img.naturalWidth),
      scaleY: imageScaleY * (image.imgHeight / img.naturalHeight),
      left: offset.left - image.left * imageScaleX,
      top: offset.top - image.top * imageScaleY,
      zIndex,
    });
    if (!hideGrounds) {
      fabricCanvas.add(fabricImg);
    }
    return {
      width: fabricImg.getScaledWidth(),
      height: fabricImg.getScaledHeight(),
    };
  } catch (e) {
    captureException(new Error(e || 'addSpreadImage: Error adding spread image to fabric'), { extra: { imageUrl } });
    return undefined;
  }
};

export default addSpreadImage;
